/* eslint-disable @typescript-eslint/no-unused-vars */
import { type ColorTheme } from "../";
import React from "react";
import { LogoLight } from "~/foundation/Components/Logo";

export const getDarkGreenColorTheme = (rtl: boolean): ColorTheme => ({
	name: "Dark Green",
	colors: {
		ribbon: {
			bg: "themeBackgroundColors.darkGreen",
			color: "primary.white",
			border: "primary.neutralGrey",
			linkColor: "primary.white"
		},
		wordExplainer: {
			bg: "primary.white",
			color: "primary.text",
			activeColor: "primary.aramcoLinkBlue"
		},
		header: {
			bg: "themeBackgroundColors.darkGreen",
			bgInactive: "navigationColors.darkBgTransparent",
			color: "primary.white",
			activeColor: "primary.text",
			hygieneColor: "primary.white",
			hygieneGlobalContacts: "primary.white",
			burgerMenuColor: "primary.white"
		},
		siteNavigation: {
			gradient: "siteNavigation.darkTheme.gradient",
			bg: "siteNavigation.darkTheme.bg",
			color: "siteNavigation.darkTheme.color",
		},
		footer: {
			bg: "themeBackgroundColors.darkGreen",
			color: "primary.white"
		},
		breadcrumb: {
			linkColor: "aramcoBreadcrumb.darkTheme.linkColor",
			activeColor: "aramcoBreadcrumb.darkTheme.activeColor",
			aramcoA: "aramcoBreadcrumb.darkTheme.aramcoA",
			iconColor: "aramcoBreadcrumb.darkTheme.iconColor",
			linkColorCurrentPage: "aramcoBreadcrumb.darkTheme.linkColorCurrentPage",
		},
		generatedCard: {
			bg: "primary.white",
			color: "primary.text",
			linkColor: "primary.aramcoLinkBlue"
		},
		tags: {
			color: "primary.neutralGrey"
		},
		switch: {
			color: "primary.white",
		}
	},
	Logo: () => <LogoLight height={25} />,
	FooterLogo: () => <LogoLight height={29} />
});